import React from "react";
import CommonModal from "../../components/Modal";
import { ModalProps } from "../../components/Modal/Modal.types";
import { useTranslation } from "react-i18next";

const DiscardCampaignModal: React.FC<ModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <CommonModal
      visible={open}
      modalTitle={t("phishingManager.discardCampaignModal.title")}
      confirmText={t("phishingManager.discardCampaignModal.confirmText")}
      cancelText={t("phishingManager.discardCampaignModal.cancelText")}
      iconType={null}
      modalContentDesc={[
        t("phishingManager.discardCampaignModal.description.line1"),
        t("phishingManager.discardCampaignModal.description.line2")
      ]}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default DiscardCampaignModal;